import {PlaneBufferGeometry} from "three";

let geom;

export const useUnitPlaneGeometry = () => {
    if (!geom) {
        geom = new PlaneBufferGeometry(1, 1);
    }
    return geom;
}